export default __webpack_public_path__ + "static/media/comics.fc5b14ed.gif";